const ANALYTICS_ID = "G-HM4WB14NFJ";
const ANALYTICS_SCRIPT_ID = "dr-hoffmann-google-tag";
const CONSENT_STORAGE_KEY = "dr_hoffmann_cookie_consent";
export const COOKIE_CONSENT_CHANGE_EVENT = "dr-hoffmann-cookie-consent-change";

export const COOKIE_CONSENT = {
  accepted: "accepted",
  declined: "declined",
};

const validDecision = (value) =>
  value === COOKIE_CONSENT.accepted || value === COOKIE_CONSENT.declined;

export function getCookieConsentDecision(user = null) {
  if (validDecision(user?.cookieConsent)) return user.cookieConsent;
  if (typeof window === "undefined") return null;

  try {
    const saved = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (validDecision(saved)) return saved;

    // Preserve choices made before consent moved from session to local storage.
    const previous = window.sessionStorage.getItem(CONSENT_STORAGE_KEY);
    if (validDecision(previous)) {
      window.localStorage.setItem(CONSENT_STORAGE_KEY, previous);
      window.sessionStorage.removeItem(CONSENT_STORAGE_KEY);
      return previous;
    }
  } catch {
    /* Browser storage may be unavailable. */
  }
  return null;
}

function storeCookieConsentDecision(decision) {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, decision);
    window.sessionStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch {
    /* ignore storage restrictions */
  }
}

function clearAnalyticsCookies() {
  const parts = window.location.hostname.split(".");
  const domains = [
    "",
    ...parts.slice(0, -1).map((_, index) =>
      `; domain=.${parts.slice(index).join(".")}`
    ),
  ];
  document.cookie.split(";").forEach((entry) => {
    const name = entry.trim().split("=")[0];
    if (!/^(_ga(?:_|$)|_gid$|_gat(?:_|$))/.test(name)) return;
    domains.forEach((domain) => {
      document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax${domain}`;
    });
  });
}

function configureGoogleTag() {
  window[`ga-disable-${ANALYTICS_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (window.__drHoffmannAnalyticsConfigured) return;

  window.gtag("js", new Date());
  window.gtag("config", ANALYTICS_ID, { send_page_view: false });
  window.__drHoffmannAnalyticsConfigured = true;
}

export function loadAnalyticsAfterConsent() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (getCookieConsentDecision() !== COOKIE_CONSENT.accepted) return;

  configureGoogleTag();

  if (document.getElementById(ANALYTICS_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = ANALYTICS_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`;
  document.head.appendChild(script);
}

export function setAnalyticsCookieConsent(decision) {
  if (typeof window === "undefined" || !validDecision(decision)) return;
  storeCookieConsentDecision(decision);

  if (decision === COOKIE_CONSENT.accepted) {
    loadAnalyticsAfterConsent();
  } else {
    window[`ga-disable-${ANALYTICS_ID}`] = true;
    clearAnalyticsCookies();
  }

  window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGE_EVENT));
}

export function acceptAnalyticsCookies() {
  setAnalyticsCookieConsent(COOKIE_CONSENT.accepted);
}

export function declineAnalyticsCookies() {
  setAnalyticsCookieConsent(COOKIE_CONSENT.declined);
}

export function isAnalyticsConsentGranted(user = null) {
  return getCookieConsentDecision(user) === COOKIE_CONSENT.accepted;
}
